import { render, staticRenderFns } from "./LectureList.vue?vue&type=template&id=3d667d35&scoped=true&"
import script from "./LectureList.vue?vue&type=script&lang=js&"
export * from "./LectureList.vue?vue&type=script&lang=js&"
import style0 from "./LectureList.vue?vue&type=style&index=0&id=3d667d35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d667d35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
